import queryString from 'qs';

import { getUrlPrefix } from './Config';

export const generateRelativeUrl = (url = ''): string => getUrlPrefix() + url;

export const urls = {
  defaultHome: generateRelativeUrl('/'),
  dashboard: generateRelativeUrl('/dashboard'),
  team: generateRelativeUrl('/team'),
  proxy: generateRelativeUrl('/proxy-team'),
  coachingNotes: generateRelativeUrl('/coaching-notes'),
  coachingHome: generateRelativeUrl('/coaching-home'),
  coachingHistory: generateRelativeUrl('/coaching-history'),
  coachingForm: generateRelativeUrl('/coaching-form'),
  realTimeHmdDetails: generateRelativeUrl('/real-time-hmd-details'),
  hmdDetails: generateRelativeUrl('/hmd-details'),
  contactTable: generateRelativeUrl('/contact-table'),
  contactReview: generateRelativeUrl('/contact-review'),
  ccxDetails: generateRelativeUrl('/ccx-details'),
  metrics: generateRelativeUrl('/metrics'),
  resourceHub: generateRelativeUrl('/resource-hub'),
  coaching: generateRelativeUrl('/coaching'),
  outlierManagement: generateRelativeUrl('/outlier-management'),
  training: generateRelativeUrl('/training'),
  trainingAssignment: generateRelativeUrl('/training/assignment'),
  pastContacts: generateRelativeUrl('/past-contacts'),
};

// We need to carry over those params to make CSC work properly
const carryOverParams = ['ie', 'marketplaceID', 'usecaseSessionID'];

export const renderUrl = (
  base: string,
  options: {
    params?: Record<string, string>;
    href?: string;
    externalDomain?: string;
  } = {}
): string => {
  let url = base;
  let newParams: Record<string, any> = {};
  // Check current params
  if (window.location.search) {
    const params = queryString.parse(window.location.search.slice(1));
    newParams = Object.keys(params)
      .filter(key => carryOverParams.includes(key))
      .reduce(
        (obj: Record<string, any>, key) => ({
          ...obj,
          [key]: params[key],
        }),
        {}
      );
  }

  // Merge current params with argument
  newParams = {
    ...newParams,
    ...options.params,
  };

  // Are there any params?
  if (Object.keys(newParams).length !== 0) {
    // Url already has '?' we need to append more get parameters
    const glue = url.includes('?') ? '&' : '?';
    url = `${url}${glue}${Object.entries(newParams)
      .map(([key, val]) => `${key}=${val}`)
      .join('&')}`;
  }

  if (options.href) {
    url = `${url}#${options.href}`;
  }

  if (options.externalDomain) {
    url = `${options.externalDomain}${url}`;
  }

  return url;
};

export const generateAbsoluteInspireUrl = (path: string) => {
  const host = window.location.host;

  return `https://${host}${path}`;
};
